import { render } from "./ProductoCard.vue?vue&type=template&id=98f714e8"
import script from "./ProductoCard.vue?vue&type=script&lang=js"
export * from "./ProductoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__